import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import BottomNavigation from './BottomNavigation';
import { MoonIcon, SunIcon, Settings } from 'lucide-react';
const Layout = () => {
  const [darkMode, setDarkMode] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.documentElement.classList.toggle('dark');
  };
  return <div className={`min-h-screen w-full flex flex-col ${darkMode ? 'dark bg-slate-900' : 'bg-warm-bg'}`} data-id="element-134">
      <header className="pt-4 pb-2 px-4 max-w-md mx-auto w-full flex justify-end items-center gap-2" data-id="element-135">
        <button onClick={() => navigate('/setup')} className="p-3 rounded-full bg-white dark:bg-slate-800 shadow-soft flex items-center justify-center" aria-label="Open settings" data-id="element-136">
          <Settings className="w-6 h-6 text-gray-600 dark:text-gray-300" data-id="element-137" />
        </button>
        <button onClick={toggleDarkMode} className="p-3 rounded-full bg-white dark:bg-slate-800 shadow-soft flex items-center justify-center" aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-138">
          {darkMode ? <SunIcon className="w-6 h-6 text-yellow-400" data-id="element-139" /> : <MoonIcon className="w-6 h-6 text-lavender" data-id="element-140" />}
        </button>
      </header>
      <main className="flex-1 pb-24 px-6 max-w-md mx-auto w-full" data-id="element-141">
        <Outlet data-id="element-142" />
      </main>
      <BottomNavigation data-id="element-143" />
    </div>;
};
export default Layout;